import FileUploader from './FileUploader';
// import IndividualGiving_Instructions from './assets/DataDefinitions_20250714.svg'
// import IndividualGivingDataFormat from './assets/DataFormat_20250714.svg'
// import logo from src/assets/IndividualGivingLogo.png
import IndividualGiving_Instructions from './assets/gifts_instructions.svg'
import OpenPledges_Instructions from './assets/pledges_instructions.svg'

function Gifts({ user, styles }) {
  return (
    <>
      {/* Rest of your code remains the same */}
      <div className="user-info">
      </div>
      <div className="file-uploader">
        <FileUploader useremail={user.attributes.email} uploadOption='gifts'/>
      </div>
      <div style={styles.instructionsContainer}>
        <img src={IndividualGiving_Instructions} alt="Data Definitions Example" style={styles.image} />
      </div>
      <div style={styles.instructionsContainer}>
        <img src={OpenPledges_Instructions} alt="Data Definitions Example" style={styles.image} />
      </div>
      {/*
      <div style={styles.instructionsContainer}>
        <h2>Upload Instructions</h2>
        <p style={styles.instructionText}>
          The data you are uploading should be in this format. Please remove any extra columns. List the column header name but leave the data blank if a field that is not required does not apply to your organization.
        </p>

        <h3>Data Format:</h3>
        <img src={IndividualGivingDataFormat} alt="Data Format Example" style={styles.image} />

        <h3>Data Definitions:</h3>
        <img src={IndividualGiving_Instructions} alt="Data Definitions Example" style={styles.image} />
      </div>
      */}
    </>
  );
}

export default Gifts;